import React from 'react'
import ReCaptcha from 'react-google-recaptcha'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputNameSF from '../../widgets/form/InputNameSF'
import InputTextSF from '../../widgets/form/InputTextSF'
import InputFieldUI from '../../widgets/form/InputFieldUI'
import InputSelectUI from '../../widgets/form/InputSelectUI'
import PriceViewUI from '../accountSettings/subscription/PriceViewUI'
import './SignUp.css'

const SignUpWithEmailUI = ({context, messageList, onSubmit, submitted, successMsg, errorList, setErrorList,
    // name
    firstName, lastName, onFirstNameChange, onLastNameChange, firstNameError, lastNameError, setFirstNameError, setLastNameError,
    // email
    email, onEmailChange, emailError, setEmailError,
    // password
    password, onPasswordChange, passwordError, setPasswordError,
    // account name
    accountName, onAccountNameChange, accountNameError, setAccountNameError,
    // country code
    countryCode, onCountryCodeChange, countryCodeError, countryList,
    // prices
    priceId, onPriceIdChange, priceList,
    // captcha
    captchaKey, onCaptchaChange, captchaRef, captchaValueError
  }) =>
  <CardUI context={context}>
    <FormSF context={context} className='pub_signup' messageList={messageList} buttonMessageKey='c_sign_up'
        onSubmit={onSubmit} successMsg={successMsg} errorList={errorList} setErrorList={setErrorList}
        busy={submitted}>
      <InputNameSF type='name' required={true} name='name' firstName={firstName} lastName={lastName}
        messageList={messageList} labelKey='c_name'
        firstNameError={firstNameError} lastNameError={lastNameError}
        onFirstNameChange={onFirstNameChange} onLastNameChange={onLastNameChange}
        setFirstNameError={setFirstNameError} setLastNameError={setLastNameError}
        autoFocus={true}
      />
      <InputTextSF type='text' name='email' required={true} maxLength={64}
        messageList={messageList} labelKey='c_email'
        value={email} onChange={onEmailChange}
        error={emailError} setError={setEmailError}
      />
      <InputTextSF type='password' name='password' required={true} maxLength={40}
        messageList={messageList} labelKey='c_password'
        value={password} onChange={onPasswordChange}
        error={passwordError} setError={setPasswordError}
      />
      <InputTextSF type='text' name='accountName' required={true} maxLength={40}
        messageList={messageList} labelKey='c_account_name'
        value={accountName} onChange={onAccountNameChange}
        error={accountNameError} setError={setAccountNameError}
      />
      <InputSelectUI name='countryCode' required={true}
        messageList={messageList} labelKey='c_country'
        value={countryCode} optionList={countryList}
        onChange={onCountryCodeChange} error={countryCodeError}
      />
      <InputFieldUI name='priceId' required={true}
        messageList={messageList} labelKey='c_plan'
      >
        <div className='price_list'>
          {
            priceList && priceList.map((price, i) =>
              <PriceViewUI key={i} context={context} messageList={messageList}
                price={price} selectedPriceId={priceId}
                selectMode={true} onSelect={onPriceIdChange}
              />
            )
          }
        </div>
      </InputFieldUI>
      <div className={`captcha ${captchaValueError ? 'hasError' : ''}`}>
        <ReCaptcha
          sitekey={captchaKey}
          onChange={onCaptchaChange}
          theme={context.theme === 'lite' ? 'light' : 'dark'}
          ref={captchaRef}
        />
      </div>
    </FormSF>
  </CardUI>

export default SignUpWithEmailUI
